import classnames from "classnames";
import { useEffect, useState } from "react";
import * as React from "react";
import { vendorRefreshFns } from "../../lib/embed";

function sanitize(nodes: NodeListOf<ChildNode>) {
  Array.from(nodes).forEach(node => {
    if (node instanceof Element) {
      node.removeAttribute("allowTransparency");
      node.removeAttribute("width");
      node.removeAttribute("height");
      node.removeAttribute("style");
    }

    if (node instanceof HTMLScriptElement) {
      const src = node.getAttribute("src");
      if (src) {
        const script = document.createElement("div");
        script.className = "component-embed-script";
        script.setAttribute("data-src", src);
        node.replaceWith(script);
      }
    }

    if (node.childNodes.length) {
      sanitize(node.childNodes);
    }
  });
  return nodes;
}

export const SanitizedEmbed = ({
  html,
  classList,
  styles,
  provider,
}: {
  html: string;
  classList: string[];
  styles?: React.CSSProperties;
  provider?: string;
}) => {
  const embed = document.createElement("div");
  embed.innerHTML = html;
  sanitize(embed.childNodes);
  const embedClass = classnames(classList);
  const [showChild, setShowChild] = useState<boolean>(false);
  useEffect(() => {
    if (showChild && provider && typeof vendorRefreshFns[provider] === "function") {
      vendorRefreshFns[provider]();
    }
  }, [showChild, provider]);

  useEffect(() => {
    setShowChild(true);
  }, []);

  if (!showChild) {
    return null;
  }

  return <div className={embedClass} style={styles} dangerouslySetInnerHTML={{ __html: embed.innerHTML }} />;
};

export default SanitizedEmbed;
